import { FilePenLineIcon, FileTextIcon, SheetIcon } from 'lucide-react';

const PDF_MIME = 'application/pdf';
const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const SPREADSHEET_MIMES = new Set<string>([
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'application/vnd.oasis.opendocument.spreadsheet',
  'text/csv',
  'text/tab-separated-values',
]);

export function DocumentFilePicto({ mimeType }: { mimeType: string }) {
  const isPdf = mimeType === PDF_MIME;
  const isWord = mimeType === DOCX_MIME;

  if (isPdf) {
    return (
      <div
        className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-rose-500/12 text-rose-700 dark:text-rose-300"
        title="PDF"
      >
        <FileTextIcon className="size-4" aria-hidden />
      </div>
    );
  }

  if (isWord) {
    return (
      <div
        className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-blue-600/12 text-blue-800 dark:text-blue-300"
        title="Word"
      >
        <FilePenLineIcon className="size-4" aria-hidden />
      </div>
    );
  }

  if (SPREADSHEET_MIMES.has(mimeType)) {
    return (
      <div
        className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-emerald-500/12 text-emerald-700 dark:text-emerald-300"
        title="Tableur"
      >
        <SheetIcon className="size-4" aria-hidden />
      </div>
    );
  }

  return (
    <div
      className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-muted/80 text-muted-foreground"
      title="Document"
    >
      <FileTextIcon className="size-4" aria-hidden />
    </div>
  );
}

